var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    [
      _c("yxt-select", {
        staticClass: "width-percent-100-i",
        attrs: {
          multiple: "",
          placeholder: _vm.$t("pc_select_placeholder" /** 请选择 */),
          "icon-name": "more",
          "hidden-option": "",
          "collapse-tags": "",
          "value-key": "userGroupId",
          "prop-label": "userGroupName",
          size: "small",
          disabled: _vm.disabled,
        },
        nativeOn: {
          click: function ($event) {
            return _vm.open.apply(null, arguments)
          },
        },
        scopedSlots: _vm._u([
          {
            key: "tag",
            fn: function (ref) {
              var data = ref.data
              return [
                _c(
                  "div",
                  { staticClass: "yxtbiz-flex-center" },
                  [
                    _c("yxt-svg", {
                      staticClass: "mr4",
                      attrs: {
                        width: "16px",
                        height: "16px",
                        "icon-class": _vm.getSvgName(data.value),
                      },
                    }),
                    _c("span", [_vm._v(_vm._s(data.currentLabel))]),
                    data.value.groupType === 5
                      ? _c(
                          "yxt-tooltip",
                          {
                            attrs: {
                              effect: "dark",
                              content: data.value.includeChildDept
                                ? _vm.$t(
                                    "pc_kng_dept_includeAll_true" /* 当前部门及后续新增子部门*/
                                  )
                                : _vm.$t(
                                    "pc_kng_dept_includeAll_false" /* 仅当前部门*/
                                  ),
                              placement: "top",
                            },
                          },
                          [
                            _c("yxt-svg", {
                              staticClass:
                                "hand color-gray-6 hover-primary-6 v-middle",
                              attrs: {
                                width: "16px",
                                height: "16px",
                                "icon-class": "question-cirlce-o",
                              },
                            }),
                          ],
                          1
                        )
                      : _vm._e(),
                  ],
                  1
                ),
              ]
            },
          },
        ]),
        model: {
          value: _vm.permissions_,
          callback: function ($$v) {
            _vm.permissions_ = $$v
          },
          expression: "permissions_",
        },
      }),
      _c(
        "yxt-drawer",
        {
          attrs: {
            size: "960px",
            "destroy-on-close": "",
            visible: _vm.visible,
          },
          on: {
            "update:visible": function ($event) {
              _vm.visible = $event
            },
          },
        },
        [
          _c("yxtbiz-range-selector", {
            ref: "selector",
            attrs: {
              tabs: [
                { type: "userGroup" },
                { type: "department", childrenIncluded: true },
                "position",
                "role",
                "persons",
              ],
              functionCode: _vm.functionCode,
              dataPermissionCode: _vm.dataPermissionCode,
            },
            model: {
              value: _vm.authList,
              callback: function ($$v) {
                _vm.authList = $$v
              },
              expression: "authList",
            },
          }),
          _c(
            "div",
            { attrs: { slot: "footer" }, slot: "footer" },
            [
              _c(
                "yxt-button",
                { attrs: { plain: "" }, on: { click: _vm.cancel } },
                [
                  _vm._v(
                    "\n        " +
                      _vm._s(_vm.$t("pc_kng_common_btn_cancel")) +
                      "\n      "
                  ),
                ]
              ),
              _c(
                "yxt-button",
                { attrs: { type: "primary" }, on: { click: _vm.confirm } },
                [
                  _vm._v(
                    "\n        " +
                      _vm._s(_vm.$t("pc_kng_common_btn_confirm")) +
                      "\n      "
                  ),
                ]
              ),
            ],
            1
          ),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }